export default "__VITE_ASSET__QqEbJhCkYMH2zruLVeLYhA__";